import type { ColumnDef } from "@tanstack/react-table";
import type { ImportRow } from "../../lib/services/catalog";

/**
 * T084/T088. One row of `GET /imports/{batchId}/rows` (`ImportRowView`). `payload` is opaque JSON
 * — the validated row as the commit would apply it — and is never parsed here: its shape differs
 * by import kind (`CatalogueImportPayload` vs `TierPriceImportPayload`) and the server already
 * validated it (constitution I never re-derives a server decision). An error row's `errorReason`
 * is shown instead, verbatim (FR-026).
 */
export const importRowColumns: ColumnDef<ImportRow, unknown>[] = [
  {
    id: "lineNumber",
    header: "Line",
    size: 90,
    meta: { align: "right" },
    cell: ({ row }) => <span className="font-mono">{row.original.lineNumber}</span>,
  },
  {
    id: "detail",
    header: "Detail",
    cell: ({ row }) =>
      row.original.errorReason ? (
        <span className="text-red-dark">{row.original.errorReason}</span>
      ) : (
        <code className="text-muted-foreground text-xs break-all">{row.original.payload}</code>
      ),
  },
];
